import axiosClient from './axiosClient';

const transactionService = {
    adminGetTransactions: async (params) => {
        const response = await axiosClient.get(`/admin/transactions`, { params });
        return response.data;
    },

    vendorGetTransactions: async (params) => {
        const response = await axiosClient.get('/vendor/transactions', { params });
        return response.data;
    }
};

export default transactionService;
